<template>
  <div>
    <div class="container">
      <!-- 左侧导航 -->
      <div class="left-nav">
        <div @click="handleSwitch(1)" :class="cli == 1 ? 'active' : ''" class="nav-item ">
          我的竞标
        </div>
        <div @click="handleSwitch(2)" :class="cli == 2 ? 'active' : ''" class="nav-item">
          个人信息
        </div>
      </div>

      <template v-if="!is_information">
        <!-- 右侧内容区 -->
        <div v-if="isDetail" class="content">
          <div class="content-header">

            我的竞标

            <div class="tag_list">
              <div @click="handleSekect(1)" :class="cli2 == 1 ? 'select' : ''" class="tag_item">
                待参与
              </div>
              <div @click="handleSekect(2)" :class="cli2 == 2 ? 'select' : ''" class="tag_item">
                已参与
              </div>
            </div>

          </div>

          <!-- 列表内容 -->
          <div class="right">
            <div class="list">
              <div class="list-item" v-for="(item, index) in 10" :key="index">
                <div class="center_box">
                  <div class="icon-doc"></div>
                  项目公告
                </div>

                <div class="setting center_box">

                  <div class="info">保证金：500元；未中标自动退。</div>

                  <div :style="index == 1 ? 'color:#333' : 'color:#999'" class="is_jiao_na">
                    {{ index == 1 ? '已缴纳' : '未缴纳' }}
                  </div>

                  <div :class="handleStyle(index)" class="tab">报名中</div>

                  <el-button @click="handleClick()" type="primary"
                    style="width:38px ;height: 27px;display: flex;align-items: center;justify-content: center;"
                    size="mini">查看</el-button>
                  <div class="time">
                    发布时间 2024-10-10
                  </div>
                </div>
              </div>
            </div>

            <!-- 分页 -->
            <div class="boxc">
              <el-pagination background layout="prev, pager, next" :total="1000">
              </el-pagination>
            </div>
          </div>
        </div>

        <div v-else class="detail">
          <div class="title">
            <span @click="isDetail = true" class="left_text">{{ '<<项目资料通知目录' }} </span>
                <span class="center">项目资料通知标题</span>
          </div>
          <!-- 文章内容 -->
          <div class="footerContent">

            文章展示

          </div>
        </div>

      </template>

      <template v-if="is_information">
        <el-form :label-position="'left'" label-width="auto" style="width: 100%;" ref="form" :model="form">

          <!-- 联系人信息 -->
          <div class="detail">
            <div class="title">
              <span class="left_text">联系人信息</span>
            </div>
            <div class="footerContent">

              <el-form-item label="业务联系人">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="业务联系人电子邮箱">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item style="margin-bottom: 0;" label="业务联系人手机号">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

            </div>
          </div>

          <!-- 供应商企业信息 -->
          <div class="detail">
            <div class="title">
              <span class="left_text">供应商企业信息</span>
            </div>
            <div class="footerContent">

              <el-form-item label="供应商名称">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="所在省市">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="注册地址(与营业执照一致)">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="注册资本（万元）">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="法定代表人姓名">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="企业性质">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="统一社会信用代码">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="公司开户银行名称">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="公司开户银行行号">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="公司银行账户号码">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="公司电话号码">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="经营范围 (与营业执照一致)">
                <el-input type="textarea" v-model="form.desc"></el-input>
              </el-form-item>

              <el-form-item label="拟提供物料或服务描述">
                <el-input class="input_style" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="近三年营业收入">
                <div class="year_styl">
                  <el-input class="input_style" v-model="form.name">
                    <template slot="prepend">去年:</template>
                  </el-input>
                  <el-input style="margin: 0 15px;" class="input_style" v-model="form.name">
                    <template slot="prepend">前年:</template>

                  </el-input>
                  <el-input class="input_style" v-model="form.name">
                    <template slot="prepend">大前年:</template>

                  </el-input>
                </div>
              </el-form-item>

              <div class="form_item">
                <div class="lable">
                  体系认证证书(质量、安全、环境、职业健康等)
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

              <div style="margin-bottom: 0;" class="form_item">
                <div class="lable">
                  营业执照
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

            </div>
          </div>

          <!-- 资质信息 -->
          <div class="detail">
            <div class="title">
              <span class="left_text">资质信息</span>
            </div>
            <div class="footerContent">

              <div class="form_item">
                <div class="lable">
                  特殊行业需提供相应许可证等资质证明
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

              <div class="form_item">
                <div class="lable">
                  信用信息公示
                  <div style="margin-left: 20px;" class="direction">
                    <a href="https://www.gsxt.gov.cn/index.html" class="url_text">https://www.gsxt.gov.cn/index.html</a>
                    <span class="footer_text">说明：前往下载（类似指引导语）</span>
                  </div>
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

              <div class="form_item">
                <div class="lable">
                  信用信息报告
                  <div style="margin-left: 20px;" class="direction">
                    <a href="https://www.gsxt.gov.cn/index.html" class="url_text">https://www.gsxt.gov.cn/index.html</a>
                    <span class="footer_text">说明：前往下载（类似指引导语）</span>
                  </div>
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

              <div class="form_item">
                <div class="lable ">
                  <div class="direction">
                    廉洁协议（签字盖章版）
                    <span class="footer_text">下载word，签字盖章后上传PDF</span>
                  </div>
                  <div style="display: flex;margin-left: 20px;">
                    <img style="width: 60px;height: 60px;" src="@/assets/word.png" alt="">
                    <div class="btn">
                      <el-button
                        style="width:38px ;height: 27px;display: flex;align-items: center;justify-content: center;"
                        size="mini">下载</el-button>
                    </div>
                  </div>
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

              <div style="margin-bottom: 0;" class="form_item">
                <div class="lable ">
                  <div class="direction">
                    信用承诺书（签字盖章版）
                    <span class="footer_text">下载word，签字盖章后上传PDF</span>
                  </div>
                  <div style="display: flex;margin-left: 20px;">
                    <img style="width: 60px;height: 60px;" src="@/assets/word.png" alt="">
                    <div class="btn">
                      <el-button
                        style="width:38px ;height: 27px;display: flex;align-items: center;justify-content: center;"
                        size="mini">下载</el-button>
                    </div>
                  </div>
                </div>

                <my-upload :limit="1" :auto-upload="false" @change="handleFileChange" @success="handleUploadSuccess"
                  @error="handleUploadError" />
              </div>

            </div>
          </div>

          <el-button style="margin-left: 20px;" type="primary">保存</el-button>

        </el-form>

      </template>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isDetail: true,
      cli: 1,
      cli2: 1,
      is_information: true, //资料说明

      form: {

      },
    };
  },
  computed: {
    handleStyle() {
      return function (e) {
        const styles = [
          'tag_style1', // 0
          'tag_style1', // 1
          'tag_style2', // 2
          'tag_style3', // 3
          'tag_style4', // 4
          'tag_style5', // 5
          'tag_style6', // 6
          'tag_style7'  // 7
        ];
        return styles[e] || ''; // 如果 e 超出范围，返回空字符串
      }
    }
  },
  methods: {

    handleFileChange(file, fileList) {
      console.log('文件变化:', file, fileList);
    },
    handleUploadSuccess(response, file, fileList) {
      console.log('上传成功:', response, file, fileList);
    },
    handleUploadError(err, file) {
      console.error('上传失败:', err, file);
    },

    handleSwitch(e) {
      this.cli = e
      if (e == 2) {
        this.is_information = true
      } else {
        this.is_information = false
      }
    },
    handleSekect(e) {
      this.cli2 = e
    },
    handleClick() {
      this.isDetail = false
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  // 图片上传区域样式
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  border: 0;
}

::v-deep .el-upload-list__item {
  //transition: none;  // 禁用上传删除动画
  transition-duration: 0.2s; // 或者不禁用，修改动画时间
}

::v-deep .el-upload-dragger {
  // 图片拖拽区域样式
  height: 100%;
  //background-color: black;
  border: none;
  line-height: 100px;

  .el-upload__text {
    // 拖拽区域文本区样式
    line-height: 1px;
  }
}


.container {
  width: 1200px;
  // height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
}

.left-nav {
  width: 200px;
  background: #f5f5f5;

  .nav-item {
    padding: 15px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.active {
      background: #c8102e;
      color: white;
    }

    i {
      margin-right: 10px;
    }
  }
}

.content {
  flex: 1;
  margin-left: 20px;
  height: 700px;

  .content-header {
    font-size: 16px;
    padding: 10px 0 0 0;

    .tag_list {
      display: flex;
      margin-top: 15px;

      .tag_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 98px;
        height: 40px;
        color: #999999;
        background-color: #DCDCDC;
        border-radius: 12px 12px 0 0;
        cursor: pointer;

      }

      .select {
        background-color: #c31424;
        color: #fff;
      }
    }
  }

  .boxc {
    display: flex;
    margin-top: 20px;
  }

  .right {
    border: 2px solid #EDEEF1;
    padding-bottom: 20px;
    border-radius: 0 0 10px 10px;
  }

  .list {

    .list-item {
      padding: 15px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: space-between;

      .icon-doc {
        width: 10px;
        height: 10px;
        background: #EDEEF1;
        margin: 0 10px 0 10px;
        border-radius: 20px;
      }

      &:hover {
        color: #c8102e;
      }

      .setting {
        width: 76%;
        display: flex;
        justify-content: space-evenly;

        .info {
          font-size: 14px;
          color: #666666;
        }

        .is_jiao_na {
          font-size: 14px;
          color: #333333;
        }

        .time {
          font-size: 14px;
          color: #999999;
        }

        .tab {
          font-size: 14px;
          padding: 2px 6px;
          box-sizing: border-box;
          border-radius: 2px;
        }

        .tag_style0 {
          border: 2px solid #6193ED;
          background-color: #eff4fd;
          color: #6193ED;
        }

        .tag_style1 {
          border: 2px solid #3CB532;
          background-color: #f5fbe7;
          color: #3CB532;
        }

        .tag_style2 {
          border: 2px solid #FFA100;
          background-color: #fff5e5;
          color: #FFA100;
        }

        .tag_style3 {
          border: 2px solid #C28EE1;
          background-color: #f6effa;
          color: #C28EE1;
        }

        .tag_style4 {
          color: #C31424;
        }

        .tag_style5 {
          color: #0256FF;

        }

        .tag_style6 {
          border: 2px solid #999999;
          background-color: #f3f3f3;
          color: #999999;
        }

        .tag_style7 {
          border: 2px solid #a40404;
          background-color: #c31424;
          color: #fff;
        }
      }
    }
  }

  .pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .page {
      padding: 5px 10px;
      margin: 0 5px;
      cursor: pointer;

      &.active {
        background: #c8102e;
        color: white;
        border-radius: 2px;
      }
    }
  }
}

.detail {
  flex: 1;
  margin-left: 20px;
  margin-bottom: 60px;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 50px;

    &::after {
      position: absolute;
      left: 0;
      bottom: -2px;
      display: block;
      content: '';
      width: 280px;
      height: 2px;
      background-color: #C31424;
    }

    .left_text {
      position: absolute;
      left: 0;
      font-size: 18px;
      color: #333;
      cursor: pointer;
    }

    .center {
      font-size: 20px;
      color: #333333;
    }
  }

  .footerContent {
    width: 100%;
    padding: 30px 21px;
    box-sizing: border-box;
    border: 2px solid #EDEEF1;
    border-radius: 0 0 10px 10px;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .input_style {
      width: 60%;
    }

    .year_styl {
      display: flex;
    }

    .form_item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .lable {
        font-size: 14px;
        color: #606266;
        display: flex;
      }

      .direction {
        display: flex;
        flex-direction: column;

        .url_text {
          font-size: 16px;
          color: #0256FF;
        }


      }

      .btn {
        display: flex;
        align-items: flex-end;
        margin-left: 15px;
      }

      .footer_text {
        font-size: 12px;
        color: #999999;
      }
    }
  }


}

.agreement-text {
  color: #666;
  font-size: 14px;
}
</style>